import { connect } from 'react-redux';
import { selectProducts } from '../stores/selectors';
import { SearchResultsList } from '../Components/SearchResultsList';

const mapStateToProps = (state: any, ownProps?: any) => {
  const products = selectProducts(state);

  return {
    ...ownProps,
    products
  };
};

export const ConnectedSearchResultsList = connect(mapStateToProps)(SearchResultsList);
